import { z as zod } from 'zod';

const inavlidEmailText = "Bitte geben Sie eine gültige E-Mail Adresse an";

export const RegisterNewsletterFormSchema = zod.object({
    email: zod.string().email(inavlidEmailText),
    firstName: zod.string().optional(),
    lastName: zod.string().optional(),
    termsAndConditionsAccepted: zod.boolean().refine((val) => val, {
        message: 'Sie müssen die Datenschutzbestimmungen lesen und akzeptieren um fortzufahren',
    })
})

export const UnregisterNewsletterFormSchema = zod.object({
    email: zod.string().email(inavlidEmailText),
    reason: zod.string().optional(),
})
